import { IDeveloper, PoiId, PoiType, User } from 'utils/entities';
import { IContactAgentValues } from 'helpers/contactFormStore';
import { Poi } from 'utils/marketplaceRoutes';
import { LeadTypeApi3 } from 'store/sagas/apiService/types';

export enum ContactType {
  Private = 'private',
  Agent = 'Agent',
  Developer = 'developer',
}

export interface CommonProps {
  poiType: PoiType;
  id: PoiId;
  contactValues: IContactAgentValues;
  poi: Poi;
  isGalleryOpen: boolean;
  agentConsole?: boolean;
  leadApi3Type: LeadTypeApi3;
}

export interface DeveloperContactProps extends CommonProps {
  cardType: ContactType.Developer;
  phone: string;
  isContacted: boolean;
  projectName: string;
  projectLogo?: string;
  developers: IDeveloper[];
  isPromoted?: boolean;
}

export interface PrivateContactProps extends CommonProps {
  cardType: ContactType.Private;
  isContacted: boolean;
  name: string;
  phone: string;
  whatsappNumber?: string;
  user?: User;
}

export interface AgentContactProps extends CommonProps {
  cardType: ContactType.Agent;
  agentName: string;
  officeName: string;
  showOnlyOffice: boolean;
  isExclusive: boolean;
  isContacted: boolean;
  officeId: string;
  agentId: string;
  isLeadingAgent: boolean;
  whatsappNumber?: string;
  hideAgentInfo: boolean;
  isDiscounted: boolean;
  officeLogo: string;
  agentLogo: string;
  phone: string;
  user: User;
  licenseId?: string;
}

export interface ContactOwnProps {
  id: PoiId;
}

export type ContactUnionProps = PrivateContactProps | AgentContactProps | DeveloperContactProps;
